import { Badge, Typography } from 'seagull';
import styles from "./RecipientDetails.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const RecipientDetails = _ref => {
  let {
    email,
    lastName,
    firstName,
    companyName,
    badge,
    testid = 'recipient-details'
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.recipientDetails,
    "data-testid": testid,
    children: [/*#__PURE__*/_jsx(Typography, {
      "data-testid": "".concat(testid, "-text"),
      children: "".concat(firstName || '', " ").concat(lastName || '').concat(companyName ? " (".concat(companyName, ")") : '', ", ").concat(email)
    }), badge === 'required' && /*#__PURE__*/_jsx(Badge, {
      rounded: true,
      outlined: true,
      children: /*#__PURE__*/_jsx(Typography, {
        skin: "disabled",
        variant: "paragraph2",
        "data-testid": "".concat(testid, "-required-badge-text"),
        children: "Required to sign"
      })
    }), badge === 'signed' && /*#__PURE__*/_jsx(Badge, {
      rounded: true,
      outlined: true,
      skin: "success",
      children: /*#__PURE__*/_jsx(Typography, {
        skin: "success",
        variant: "paragraph2",
        "data-testid": "".concat(testid, "-signed-badge-text"),
        children: "Signed"
      })
    })]
  });
};
export default RecipientDetails;